




































































import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";

import NavBarMenu from "@/components/NavBarMenu.vue";
import TitleBar from "@/components/TitleBar.vue";
import UserAvatar from "@/components/UserAvatar.vue";

@Component({
  computed: {
    ...mapState([
      "isNavBarVisible",
      "isAsideExpanded",
      "isAsideMobileExpanded",
      "isAsideRightVisible",
      "userName",
      "hasUpdates",
      "breadcrumbs"
    ])
  },
  components: {
    UserAvatar,
    NavBarMenu,
    TitleBar
  }
})
export default class NavBar extends Vue {
  // Mapped from vuex
  isNavBarVisible!: boolean;
  isAsideExpanded!: boolean;
  isAsideMobileExpanded!: boolean;
  isAsideRightVisible!: boolean;
  userName!: string;
  hasUpdates!: boolean;

  // Other variables
  isMenuNavBarActive = false;

  // Getters
  get menuNavBarToggleIcon() {
    return this.isMenuNavBarActive ? "close" : "dots-vertical";
  }

  get menuToggleMobileIcon() {
    return this.isAsideMobileExpanded ? "backburger" : "forwardburger";
  }

  get menuToggleIcon() {
    return this.isAsideExpanded ? "backburger" : "forwardburger";
  }

  get toggleTooltip() {
    return this.isAsideExpanded ? "Collapse" : "Expand";
  }

  // Methods
  menuToggle() {
    this.$store.commit("asideStateToggle");
  }

  menuToggleMobile() {
    this.$store.commit("asideMobileStateToggle");
  }

  menuNavBarToggle() {
    this.isMenuNavBarActive = !this.isMenuNavBarActive;
  }

  updatesToggle() {
    this.$store.commit("asideRightToggle");
  }

  logout() {
    this.$buefy.snackbar.open({
      message: "Log out clicked",
      queue: false
    });
  }
}
